import { useMemo } from "react";
import { useHotelRoomCardRates as useCoreHotelRoomCardRates } from "@b2bportal/core-hotels";
import type { HotelRoomCardRatesProps } from "@b2bportal/core-hotels";
import { useI18nContext } from "@hopper-b2b/i18n";

export const useHotelRoomCardRates = (props: HotelRoomCardRatesProps) => {
  const coreHook = useCoreHotelRoomCardRates(props);
  const { formatFiatCurrency, t } = useI18nContext();

  const additionalText = useMemo(() => {
    const totalPriceFormatted = formatFiatCurrency(
      props.selectedProduct.tripTotal.fiat
    );

    const totalDiscountAwarePrices =
      props.selectedProduct.totalDiscountAwareTaxesAndFeesIncluded;
    const hasDiscount =
      totalDiscountAwarePrices?.priceWithNoDiscounts?.fiat?.value !==
      totalDiscountAwarePrices?.priceWithAllDiscounts?.fiat?.value;

    return {
      totalPrice: t("core-hotels.roomSelection.totalPrice", {
        price: totalPriceFormatted,
      }),
      totalNotDiscounted:
        hasDiscount && totalDiscountAwarePrices?.priceWithNoDiscounts?.fiat
          ? formatFiatCurrency(
              totalDiscountAwarePrices.priceWithNoDiscounts.fiat
            )
          : undefined,
      taxesAndFeesIncludedDisclaimer: t(
        "core-hotels.roomSelection.taxesAndFeesIncluded"
      ),
    };
  }, [props.selectedProduct, formatFiatCurrency, t]);

  return {
    ...coreHook,
    text: {
      selectedPrice: coreHook.text.selectedPrice,
      totalPrice: additionalText.totalPrice,
      totalNotDiscounted: additionalText.totalNotDiscounted,
      taxesAndFeesIncludedDisclaimer:
        additionalText.taxesAndFeesIncludedDisclaimer,
    },
  };
};
